var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"pic",attrs:{"src":require("@/assets/noOpen.png"),"alt":""}}),_c('span',[_vm._v("业务待接入，敬请期待")])])])
}]

export { render, staticRenderFns }